import React, { useEffect, useState } from "react";
import Layout from "../../components/layout";
import {
  FaArrowLeft,
  FaSearch,
  FaCalendarAlt,
  FaInfoCircle,
} from "react-icons/fa";

import styles from "./OrdersPage.module.scss";
import { useNavigate } from "react-router-dom";
import { route } from "../../static/route";
import Select from "react-select";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  fetchItemsList,
  fetchOrdersListData,
  fetchProcessesList,
  getItems,
  getOrders,
  getParties,
  getProcesses,
  getTotalOrders,
  fetchPartiesList,
  fetchEditPartyItemsList,
  getEditPartyItems,
  getIsOrderModalOpen,
  getEditOrder,
  setEditOrder,
  getTotalAmount,
  getIsOrderPhotoModalOpen,
} from "../../features/orders/ordersSlice";
import Pagination from "../../components/pagination";
import { toast } from "react-toastify";
import { selectStyles, multiSelectStyles, toastStyles } from "../../static/styles";
import { DELETE, GET, POST, PUT } from "../../services/axios.service";
import { Controller, useForm } from "react-hook-form";
import OrderList from "../../components/orders/OrderList";
import { IFormInput, OptionsProps } from "../../types/orders";
import OrdersFormModal from "../../components/orders/OrdersFormModal";
import PhotoModel from "../../components/orders/PhotoModel";
import moment from "moment";

const OrdersPage = () => {
  const companyName = process.env.REACT_APP_COMPANY_NAME;

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const orders = useAppSelector(getOrders);
  const totalOrders = useAppSelector(getTotalOrders);
  const totalAmount = useAppSelector(getTotalAmount);
  const items = useAppSelector(getItems);
  const processes = useAppSelector(getProcesses);
  const parties = useAppSelector(getParties);
  const isOrderModalOpen = useAppSelector(getIsOrderModalOpen);
  const editOrder = useAppSelector(getEditOrder);
  const isOrderPhotoModalOpen = useAppSelector(getIsOrderPhotoModalOpen);
  const editPartyItems = useAppSelector(getEditPartyItems);

  const [itemOption, setItemOption] = useState<OptionsProps[]>([]);
  const [processOption, setProcessOption] = useState<OptionsProps[]>([]);
  const [filteredItemOption, setFilteredItemOption] = useState<OptionsProps[]>([]);
  const [filteredProcessOption, setFilteredProcessOption] = useState<OptionsProps[]>([]);
  const [filteredExportItemOption, setFilteredExportItemOption] = useState<OptionsProps[]>([]);
  const [filteredExportProcessOption, setFilteredExportProcessOption] = useState<OptionsProps[]>([]);
  const [partyOption, setPartyOption] = useState<OptionsProps[]>([]);
  const [statusOption] = useState<OptionsProps[]>([
    {
      value: 0,
      label: "ચાલુ કામ",
    },
    {
      value: 1,
      label: "પૂરું થયેલું કામ",
    },
  ]);
  const [typeOption] = useState<OptionsProps[]>([
    {
      value: 0,
      label: "કામ ના આધારે",
    },
    {
      value: 1,
      label: "પાર્ટી ના આધારે",
    },
  ]);
  const [unitOption] = useState<OptionsProps[]>([
    {
      value: 1,
      label: "વજન - KG",
    },
    {
      value: 2,
      label: "નંગ - Piece",
    },
    {
      value: 3,
      label: "જોડી - Pair",
    },
  ]);
  const [amountOption] = useState<OptionsProps[]>([
    {
      value: 0,
      label: "અમાઉન્ટ સાથે",
    },
    {
      value: 1,
      label: "અમાઉન્ટ વિના",
    },
  ]);

  interface FilterFormInput {
    name: string;
    fromDate: string;
    toDate: string;
    party_id: number;
    item_ids: number[];
    process_ids: number[];
    status: number;
    unit_ids: number[];
  }

  interface ExportFormInput {
    fromDate: string;
    toDate: string;
    party_id: number;
    item_ids: number[];
    process_ids: number[];
    status: number;
    type: number;
    unit_ids: number[];
    amount_type: number;
  }

  const { handleSubmit, register, reset, getValues, control, setValue } =
    useForm<FilterFormInput>();

  const {
    handleSubmit: handleSubmit1,
    register: register1,
    reset: reset1,
    control: control1,
    setValue: setValue1,
    getValues: getValues1,
  } = useForm<ExportFormInput>();

  const [page, setPage] = useState<number>(1);
  const [pageSize] = useState<number>(50);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showFilter, setShowFilter] = useState(false);
  const [showExport, setShowExport] = useState(false);
  // Orders ticked in the list; kept across page and filter changes.
  const [selectedOrderIds, setSelectedOrderIds] = useState<number[]>([]);

  const hasSelectedOrders = selectedOrderIds.length > 0;
  // Report-panel fields that are ignored while orders are ticked get dimmed.
  const exportIgnoredClass = hasSelectedOrders ? " opacity-50" : "";

  const hanldeGoToHome = () => {
    navigate(route.dashboard);
  };

  const paginate = (pageNumber: number) => {
    setPage(pageNumber);
  };

  const handleToggleOrder = (id: number) => {
    setSelectedOrderIds((prev) =>
      prev.includes(id)
        ? prev.filter((orderId) => orderId !== id)
        : [...prev, id]
    );
  };

  const handleTogglePageOrders = (ids: number[], checked: boolean) => {
    setSelectedOrderIds((prev) =>
      checked
        ? [...prev, ...ids.filter((id) => !prev.includes(id))]
        : prev.filter((id) => !ids.includes(id))
    );
  };

  const handleClearSelection = () => {
    setSelectedOrderIds([]);
  };

  const handleDeleteOrder = async (id: number, password: string) => {
    try {
      await DELETE(`/v1/admin/orders/${id}`, {
        password: password,
      })
        .then(async (response: any) => {
          if (response.data.status === "success") {
            setSelectedOrderIds((prev) =>
              prev.filter((orderId) => orderId !== id)
            );

            const pageNumber = orders.length > 1 ? page : page - 1;
            if (page === pageNumber) {
              fetchOrdersList(page, pageSize);
            } else {
              setPage(pageNumber);
            }

            toast.success(response.data.message, {
              ...(toastStyles as any),
            });
          } else {
            toast.error(response.data.message, {
              ...(toastStyles as any),
            });
          }
        })
        .catch((error: any) => {
          toast.error(error.data.message, {
            ...(toastStyles as any),
          });
        });
    } catch (error) {
      toast.error("કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.", {
        ...(toastStyles as any),
      });
    }
  };

  const handleOnFilterSubmit = async () => {
    fetchOrdersList(page, pageSize);
  };

  const handleOnExportSubmit = async (data: ExportFormInput) => {
    try {
      // Ticked orders: work-wise report of exactly those orders (dates and other
      // filters are ignored). POST keeps a large selection out of the URL.
      const reportRequest = hasSelectedOrders
        ? POST(`/v1/admin/reports`, {
            type: 0,
            order_ids: selectedOrderIds,
            amount_type: data.amount_type,
          })
        : GET(`/v1/admin/reports`, {
            fromDate: data.fromDate,
            toDate: data.toDate,
            party_id: data.party_id,
            type: data.type,
            status: data.status,
            item_ids: data.item_ids?.length ? data.item_ids : null,
            unit_ids: data.unit_ids?.length ? data.unit_ids : null,
            amount_type: data.amount_type,
            process_ids: data.process_ids?.length ? data.process_ids : null,
          });

      await reportRequest
        .then(async (response: any) => {
          if (response.data.status === "success") {
            toast.success(response.data.message, {
              ...(toastStyles as any),
            });

            const downloadLink = response.data.data.download_link;
            try {
              const newWindow = window.open(downloadLink, "_blank");
              if (
                !newWindow ||
                newWindow.closed ||
                typeof newWindow.closed == "undefined"
              ) {
                throw new Error("પોપ્અપ બ્લોક કરેલ છે.");
              }
            } catch (e) {
              window.location.href = downloadLink;
            }
          } else {
            toast.error(response.data.message, {
              ...(toastStyles as any),
            });
          }
        })
        .catch((error: any) => {
          toast.error(error.data.message, {
            ...(toastStyles as any),
          });
        });
    } catch (error) {
      toast.error("કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.", {
        ...(toastStyles as any),
      });
    }
  };

  const handleClearFilter = () => {
    reset();
    setFilteredItemOption(itemOption);
    setFilteredProcessOption(processOption);
    fetchOrdersList(page, pageSize);
  };

  const handleClearExport = () => {
    reset1();
    setFilteredExportItemOption(itemOption);
    setFilteredExportProcessOption(processOption);
  };

  const fetchOrdersList = async (page: number, size: number) => {
    const data = getValues();

    setIsLoading(true);

    dispatch(
      fetchOrdersListData({
        page: page,
        size: size,
        search: data?.name || null,
        fromDate: data?.fromDate || null,
        toDate: data?.toDate || null,
        party_id: data?.party_id || null,
        item_ids: data?.item_ids?.length ? data.item_ids : null,
        process_ids: data?.process_ids?.length ? data.process_ids : null,
        status: data?.status || data?.status === 0 ? data?.status : null,
        unit_ids: data?.unit_ids?.length ? data.unit_ids : null,
      })
    ).then(() => {
      setIsLoading(false);
    });
  };

  const handleSaveOrder = async (data: IFormInput) => {
    try {
      if (editOrder) {
        await PUT(`/v1/admin/orders/${editOrder.id}`, {
          item_id: data.item_id,
          process_id: data.process_id,
          unit_id: data.unit_id,
          qty: data.qty,
          weight: data.weight || 0,
          status: data.status || 0,
          rate: data.rate,
          design: data.design,
          created_at: moment(data.created_at).format("YYYY-MM-DD H:mm:ss"),
        })
          .then(async (response: any) => {
            if (response.data.status === "success") {
              await dispatch(setEditOrder(null));

              fetchOrdersList(page, pageSize);

              toast.success(response.data.message, {
                ...(toastStyles as any),
              });
            } else {
              toast.error(response.data.message, {
                ...(toastStyles as any),
              });
            }
          })
          .catch((error: any) => {
            toast.error(error.data.message, {
              ...(toastStyles as any),
            });
          });
      }
    } catch (error) {
      toast.error("કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.", {
        ...(toastStyles as any),
      });
    }
  };

  useEffect(() => {
    fetchOrdersList(page, pageSize);
  }, [page]);

  useEffect(() => {
    const options =
      items?.map((item) => ({ value: item.id, label: item.name })) ?? [];
    setItemOption(options);
    if (!getValues("party_id")) {
      setFilteredItemOption(options);
    }
    if (!getValues1("party_id")) {
      setFilteredExportItemOption(options);
    }
  }, [items]);

  useEffect(() => {
    const options =
      processes?.map((process) => ({
        value: process.id,
        label: process.name,
      })) ?? [];
    setProcessOption(options);
    if (!getValues("party_id")) {
      setFilteredProcessOption(options);
    }
    if (!getValues1("party_id")) {
      setFilteredExportProcessOption(options);
    }
  }, [processes]);

  // When editPartyItems changes (party selected), update filtered item/process options
  useEffect(() => {
    if (editPartyItems && editPartyItems.length > 0) {
      const partyItemOptions = editPartyItems.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setFilteredItemOption(partyItemOptions);
      setFilteredExportItemOption(partyItemOptions);

      // Collect all processes from all party items
      const allProcesses: OptionsProps[] = [];
      const seenProcessIds = new Set<number>();
      editPartyItems.forEach((item) => {
        item.processes?.forEach((proc) => {
          if (!seenProcessIds.has(proc.id)) {
            seenProcessIds.add(proc.id);
            allProcesses.push({ value: proc.id, label: proc.name });
          }
        });
      });
      setFilteredProcessOption(allProcesses);
      setFilteredExportProcessOption(allProcesses);

      // Clear selected items/processes that no longer apply (filter form)
      const validItemIds = new Set(editPartyItems.map((i) => i.id));
      const currentItemIds = getValues("item_ids") || [];
      const newItemIds = currentItemIds.filter((id: number) => validItemIds.has(id));
      if (newItemIds.length !== currentItemIds.length) {
        setValue("item_ids", newItemIds);
      }

      const validProcessIds = new Set(allProcesses.map((p) => p.value));
      const currentProcessIds = getValues("process_ids") || [];
      const newProcessIds = currentProcessIds.filter((id: number) => validProcessIds.has(id));
      if (newProcessIds.length !== currentProcessIds.length) {
        setValue("process_ids", newProcessIds);
      }

      // Clear selected items/processes that no longer apply (export form)
      const currentExportItemIds = getValues1("item_ids") || [];
      const newExportItemIds = currentExportItemIds.filter((id: number) => validItemIds.has(id));
      if (newExportItemIds.length !== currentExportItemIds.length) {
        setValue1("item_ids", newExportItemIds);
      }

      const currentExportProcessIds = getValues1("process_ids") || [];
      const newExportProcessIds = currentExportProcessIds.filter((id: number) => validProcessIds.has(id));
      if (newExportProcessIds.length !== currentExportProcessIds.length) {
        setValue1("process_ids", newExportProcessIds);
      }
    }
  }, [editPartyItems]);

  useEffect(() => {
    const options =
      parties?.map((party) => ({
        value: party.id,
        label:
          party.firm_name +
          (party.name ? " - " + party.name : "") +
          (party.phone ? " (" + party.phone + ")" : ""),
      })) ?? [];
    setPartyOption(options);
  }, [parties]);

  useEffect(() => {
    dispatch(fetchItemsList());
    dispatch(fetchProcessesList());
    dispatch(fetchPartiesList());
  }, []);

  return (
    <Layout>
      <div className={styles.OrdersPage}>
        <div className="logoSection">
          <h1
            onClick={hanldeGoToHome}
            className="text-4xl font-bold text-white lg:text-2xl cursor-pointer lg:w-fit"
          >
            {companyName}
          </h1>

          <hr className="w-[180px] border-white border-[4px] rounded-[4px] mx-auto mt-4 lg:mx-0 lg:w-24 lg:border-[2px] lg:mt-2" />
        </div>

        <div className="pageTitleSection">
          <FaArrowLeft
            onClick={hanldeGoToHome}
            className="lg:hidden absolute top-5 left-5 text-3xl text-white border-2 border-white p-1 rounded-full"
          />

          <h1 className="text-5xl mt-6 lg:mt-0 font-bold text-white lg:text-2xl lg:text-primary-1">
            ઓર્ડર ની વિગતો
          </h1>
        </div>

        <div className="mt-[60px] px-10 py-5">
          <div className="flex justify-end gap-4 items-center mb-4">
            <p className="text-primary-1 font-bold mt-auto hidden">
              ટોટલ અમાઉન્ટ: {totalAmount.toFixed(2) || 0.0}
            </p>

            <div className="grid lg:flex gap-4">
              <button
                className="p-2 rounded-md flex items-center bg-gradient-to-r from-primary-1 to-primary-2 text-white transition-colors duration-300"
                onClick={() => {
                  if (!showExport === true) setShowFilter(false);
                  setShowExport(!showExport);
                }}
              >
                <FaSearch className="mr-2" />{" "}
                {showExport ? "રિપોર્ટ છુપાવો" : "રિપોર્ટ બતાવો"}
                {hasSelectedOrders && ` (${selectedOrderIds.length})`}
              </button>

              <button
                className="p-2 rounded-md flex items-center bg-gradient-to-r from-primary-1 to-primary-2 text-white transition-colors duration-300"
                onClick={() => {
                  if (!showFilter === true) setShowExport(false);
                  setShowFilter(!showFilter);
                }}
              >
                <FaSearch className="mr-2" />{" "}
                {showFilter ? "ફિલ્ટર છુપાવો" : "ફિલ્ટર બતાવો"}
              </button>
            </div>
          </div>

          {showFilter && (
            <form onSubmit={handleSubmit(handleOnFilterSubmit)}>
              <div className="mb-4 bg-white shadow rounded p-4">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div className="flex items-center bg-gradient-to-r from-primary-1 to-primary-2 rounded pr-[2px] h-[44px]">
                    <FaCalendarAlt className="text-white mx-2" />
                    <input
                      className="bg-white text-primary-1 placeholder:text-primary-2 font-semibold text-xl focus:outline-none p-2 rounded flex-grow h-[40px]"
                      type="date"
                      {...register("fromDate")}
                      placeholder="From Date"
                    />
                  </div>

                  <div className="flex items-center bg-gradient-to-r from-primary-1 to-primary-2 rounded pr-[2px] h-[44px]">
                    <FaCalendarAlt className="text-white mx-2" />
                    <input
                      className="bg-white text-primary-1  placeholder:text-primary-2 font-semibold text-xl focus:outline-none p-2 rounded flex-grow h-[40px]"
                      type="date"
                      {...register("toDate")}
                      placeholder="To Date"
                    />
                  </div>

                  <div className="flex items-center bg-gradient-to-r from-primary-1 to-primary-2 rounded p-[2px] h-[44px]">
                    <input
                      {...register("name")}
                      className="text-primary-1 px-3 py-1 font-semibold text-xl placeholder:text-primary-2 w-full h-full rounded focus:outline-none"
                      placeholder="ઓર્ડર ID દ્વારા શોધો"
                    />
                  </div>

                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-12 w-full relative rounded">
                    <Controller
                      {...register("party_id")}
                      control={control}
                      render={({ field }) => (
                        <Select
                          isClearable
                          {...field}
                          value={
                            partyOption.find(
                              (val) => val.value === field.value
                            ) || null
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                          styles={selectStyles}
                          placeholder={"પાર્ટી નું નામ સિલેક્ટ કરો"}
                          options={partyOption}
                          onChange={(val: any) => {
                            setValue("party_id", val?.value);
                            setValue("item_ids", []);
                            setValue("process_ids", []);
                            if (val?.value) {
                              dispatch(fetchEditPartyItemsList(val.value));
                            } else {
                              setFilteredItemOption(itemOption);
                              setFilteredProcessOption(processOption);
                            }
                          }}
                        />
                      )}
                    />
                  </div>

                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 p-[2px] min-h-[64px] lg:min-h-[48px] w-full rounded">
                    <Controller
                      {...register("item_ids")}
                      control={control}
                      render={({ field }) => (
                        <Select
                          isClearable
                          isMulti
                          {...field}
                          value={
                            filteredItemOption.filter((val) =>
                              field.value?.includes(val.value)
                            ) || []
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 w-full h-full rounded"
                          styles={multiSelectStyles}
                          placeholder={"આઈટમ નું નામ સિલેક્ટ કરો"}
                          options={filteredItemOption}
                          onChange={(val: any) => {
                            const selectedIds = val?.map((v: any) => v.value) || [];
                            setValue("item_ids", selectedIds);
                            // Filter processes based on selected items when party is active
                            if (getValues("party_id") && editPartyItems.length > 0) {
                              if (selectedIds.length > 0) {
                                const filteredProcs: OptionsProps[] = [];
                                const seenIds = new Set<number>();
                                editPartyItems
                                  .filter((item) => selectedIds.includes(item.id))
                                  .forEach((item) => {
                                    item.processes?.forEach((proc) => {
                                      if (!seenIds.has(proc.id)) {
                                        seenIds.add(proc.id);
                                        filteredProcs.push({ value: proc.id, label: proc.name });
                                      }
                                    });
                                  });
                                setFilteredProcessOption(filteredProcs);
                                // Clear processes that no longer apply
                                const validIds = new Set(filteredProcs.map((p) => p.value));
                                const currentProcessIds = getValues("process_ids") || [];
                                setValue("process_ids", currentProcessIds.filter((id: number) => validIds.has(id)));
                              } else {
                                // No items selected, show all processes for this party
                                const allProcs: OptionsProps[] = [];
                                const seenIds = new Set<number>();
                                editPartyItems.forEach((item) => {
                                  item.processes?.forEach((proc) => {
                                    if (!seenIds.has(proc.id)) {
                                      seenIds.add(proc.id);
                                      allProcs.push({ value: proc.id, label: proc.name });
                                    }
                                  });
                                });
                                setFilteredProcessOption(allProcs);
                              }
                            }
                          }}
                        />
                      )}
                    />
                  </div>

                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 p-[2px] min-h-[64px] lg:min-h-[48px] w-full rounded">
                    <Controller
                      {...register("process_ids")}
                      control={control}
                      render={({ field }) => (
                        <Select
                          isClearable
                          isMulti
                          {...field}
                          value={
                            filteredProcessOption.filter((val) =>
                              field.value?.includes(val.value)
                            ) || []
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 w-full h-full rounded"
                          styles={multiSelectStyles}
                          placeholder={"પ્રોસેસ નું નામ સિલેક્ટ કરો"}
                          options={filteredProcessOption}
                          onChange={(val: any) =>
                            setValue("process_ids", val?.map((v: any) => v.value) || [])
                          }
                        />
                      )}
                    />
                  </div>

                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 p-[2px] min-h-[64px] lg:min-h-[48px] w-full rounded">
                    <Controller
                      {...register("unit_ids")}
                      control={control}
                      render={({ field }) => (
                        <Select
                          isClearable
                          isMulti
                          {...field}
                          value={
                            unitOption.filter((val) =>
                              field.value?.includes(val.value)
                            ) || []
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 w-full h-full rounded"
                          styles={multiSelectStyles}
                          placeholder={"યુનિટ નું નામ સિલેક્ટ કરો"}
                          options={unitOption}
                          onChange={(val: any) =>
                            setValue("unit_ids", val?.map((v: any) => v.value) || [])
                          }
                        />
                      )}
                    />
                  </div>

                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-12 w-full relative rounded">
                    <Controller
                      {...register("status")}
                      control={control}
                      render={({ field }) => (
                        <Select
                          isClearable
                          {...field}
                          value={
                            statusOption.find(
                              (val) => val.value === field.value
                            ) || null
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                          styles={selectStyles}
                          placeholder={"સ્ટેટ્સ નું નામ સિલેક્ટ કરો"}
                          options={statusOption}
                          onChange={(val: any) =>
                            setValue("status", val?.value)
                          }
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="flex gap-4 justify-end mt-4">
                  <button
                    onClick={handleClearFilter}
                    type="button"
                    className="bg-primary-1 hover:bg-primary-2 text-white px-4 py-2 rounded-md transition duration-300 ease-in-out"
                  >
                    હટાઓ
                  </button>

                  <button
                    type="submit"
                    className="bg-primary-1 hover:bg-primary-2 text-white px-4 py-2 rounded-md transition duration-300 ease-in-out"
                  >
                    ફિલ્ટર લાગુ કરો
                  </button>
                </div>
              </div>
            </form>
          )}

          {showExport && (
            <form onSubmit={handleSubmit1(handleOnExportSubmit)}>
              <div className="mb-4 bg-white shadow rounded p-4">
                {hasSelectedOrders && (
                  <div className="mb-4 flex flex-col gap-3 rounded border border-primary-1 bg-indigo-50 p-3 md:flex-row md:items-center md:justify-between">
                    <p className="flex items-center text-primary-1 font-semibold">
                      <FaInfoCircle className="mr-2 shrink-0" />
                      {selectedOrderIds.length} ઓર્ડર સિલેક્ટ કરેલા છે. રિપોર્ટ
                      માં ફક્ત આ જ ઓર્ડર આવશે.
                    </p>
                    <button
                      type="button"
                      onClick={handleClearSelection}
                      className="self-end md:self-auto bg-primary-1 hover:bg-primary-2 text-white px-4 py-2 rounded-md transition duration-300 ease-in-out"
                    >
                      સિલેક્શન હટાઓ
                    </button>
                  </div>
                )}

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div
                    className={`flex items-center bg-gradient-to-r from-primary-1 to-primary-2 rounded pr-[2px] h-[44px]${exportIgnoredClass}`}
                  >
                    <FaCalendarAlt className="text-white mx-2" />
                    <input
                      className="bg-white text-primary-1 placeholder:text-primary-2 font-semibold text-xl focus:outline-none p-2 rounded flex-grow h-[40px] disabled:cursor-not-allowed"
                      type="date"
                      {...register1("fromDate")}
                      disabled={hasSelectedOrders}
                      placeholder="From Date"
                    />
                  </div>

                  <div
                    className={`flex items-center bg-gradient-to-r from-primary-1 to-primary-2 rounded pr-[2px] h-[44px]${exportIgnoredClass}`}
                  >
                    <FaCalendarAlt className="text-white mx-2" />
                    <input
                      className="bg-white text-primary-1  placeholder:text-primary-2 font-semibold text-xl focus:outline-none p-2 rounded flex-grow h-[40px] disabled:cursor-not-allowed"
                      type="date"
                      {...register1("toDate")}
                      disabled={hasSelectedOrders}
                      placeholder="To Date"
                    />
                  </div>

                  <div
                    className={`bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-11 w-full relative rounded${exportIgnoredClass}`}
                  >
                    <Controller
                      {...register1("party_id")}
                      control={control1}
                      render={({ field }) => (
                        <Select
                          isClearable
                          {...field}
                          isDisabled={hasSelectedOrders}
                          value={
                            partyOption.find(
                              (val) => val.value === field.value
                            ) || null
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                          styles={selectStyles}
                          placeholder={"પાર્ટી નું નામ સિલેક્ટ કરો"}
                          options={partyOption}
                          onChange={(val: any) => {
                            setValue1("party_id", val?.value);
                            setValue1("item_ids", []);
                            setValue1("process_ids", []);
                            if (val?.value) {
                              dispatch(fetchEditPartyItemsList(val.value));
                            } else {
                              setFilteredExportItemOption(itemOption);
                              setFilteredExportProcessOption(processOption);
                            }
                          }}
                        />
                      )}
                    />
                  </div>

                  <div
                    className={`bg-gradient-to-r from-primary-1 to-primary-2 p-[2px] min-h-[64px] lg:min-h-[48px] w-full rounded${exportIgnoredClass}`}
                  >
                    <Controller
                      {...register1("item_ids")}
                      control={control1}
                      render={({ field }) => (
                        <Select
                          isClearable
                          isMulti
                          {...field}
                          isDisabled={hasSelectedOrders}
                          value={
                            filteredExportItemOption.filter((val) =>
                              field.value?.includes(val.value)
                            ) || []
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 w-full h-full rounded"
                          styles={multiSelectStyles}
                          placeholder={"આઈટમ નું નામ સિલેક્ટ કરો"}
                          options={filteredExportItemOption}
                          onChange={(val: any) => {
                            const selectedIds = val?.map((v: any) => v.value) || [];
                            setValue1("item_ids", selectedIds);
                            if (getValues1("party_id") && editPartyItems.length > 0) {
                              if (selectedIds.length > 0) {
                                const filteredProcs: OptionsProps[] = [];
                                const seenIds = new Set<number>();
                                editPartyItems
                                  .filter((item) => selectedIds.includes(item.id))
                                  .forEach((item) => {
                                    item.processes?.forEach((proc) => {
                                      if (!seenIds.has(proc.id)) {
                                        seenIds.add(proc.id);
                                        filteredProcs.push({ value: proc.id, label: proc.name });
                                      }
                                    });
                                  });
                                setFilteredExportProcessOption(filteredProcs);
                                const validIds = new Set(filteredProcs.map((p) => p.value));
                                const currentProcessIds = getValues1("process_ids") || [];
                                setValue1("process_ids", currentProcessIds.filter((id: number) => validIds.has(id)));
                              } else {
                                const allProcs: OptionsProps[] = [];
                                const seenIds = new Set<number>();
                                editPartyItems.forEach((item) => {
                                  item.processes?.forEach((proc) => {
                                    if (!seenIds.has(proc.id)) {
                                      seenIds.add(proc.id);
                                      allProcs.push({ value: proc.id, label: proc.name });
                                    }
                                  });
                                });
                                setFilteredExportProcessOption(allProcs);
                              }
                            }
                          }}
                        />
                      )}
                    />
                  </div>

                  <div
                    className={`bg-gradient-to-r from-primary-1 to-primary-2 p-[2px] min-h-[64px] lg:min-h-[48px] w-full rounded${exportIgnoredClass}`}
                  >
                    <Controller
                      {...register1("process_ids")}
                      control={control1}
                      render={({ field }) => (
                        <Select
                          isClearable
                          isMulti
                          {...field}
                          isDisabled={hasSelectedOrders}
                          value={
                            filteredExportProcessOption.filter((val) =>
                              field.value?.includes(val.value)
                            ) || []
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 w-full h-full rounded"
                          styles={multiSelectStyles}
                          placeholder={"પ્રોસેસ નું નામ સિલેક્ટ કરો"}
                          options={filteredExportProcessOption}
                          onChange={(val: any) =>
                            setValue1("process_ids", val?.map((v: any) => v.value) || [])
                          }
                        />
                      )}
                    />
                  </div>

                  <div
                    className={`bg-gradient-to-r from-primary-1 to-primary-2 p-[2px] min-h-[64px] lg:min-h-[48px] w-full rounded${exportIgnoredClass}`}
                  >
                    <Controller
                      {...register1("unit_ids")}
                      control={control1}
                      render={({ field }) => (
                        <Select
                          isClearable
                          isMulti
                          {...field}
                          isDisabled={hasSelectedOrders}
                          value={
                            unitOption.filter((val) =>
                              field.value?.includes(val.value)
                            ) || []
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 w-full h-full rounded"
                          styles={multiSelectStyles}
                          placeholder={"યુનિટ નું નામ સિલેક્ટ કરો"}
                          options={unitOption}
                          onChange={(val: any) =>
                            setValue1("unit_ids", val?.map((v: any) => v.value) || [])
                          }
                        />
                      )}
                    />
                  </div>

                  <div
                    className={`bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-11 w-full relative rounded${exportIgnoredClass}`}
                  >
                    <Controller
                      {...register1("status")}
                      control={control1}
                      render={({ field }) => (
                        <Select
                          isClearable
                          {...field}
                          isDisabled={hasSelectedOrders}
                          value={
                            statusOption.find(
                              (val) => val.value === field.value
                            ) || null
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                          styles={selectStyles}
                          placeholder={"સ્ટેટ્સ નું નામ સિલેક્ટ કરો"}
                          options={statusOption}
                          onChange={(val: any) =>
                            setValue1("status", val?.value)
                          }
                        />
                      )}
                    />
                  </div>

                  <div
                    className={`bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-11 w-full relative rounded${exportIgnoredClass}`}
                  >
                    <Controller
                      {...register1("type")}
                      control={control1}
                      defaultValue={0}
                      render={({ field }) => (
                        <Select
                          isClearable
                          {...field}
                          isDisabled={hasSelectedOrders}
                          value={
                            // Ticked orders always give the work-wise (type 0) report.
                            typeOption.find(
                              (val) =>
                                val.value ===
                                (hasSelectedOrders ? 0 : field.value)
                            ) || null
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                          styles={selectStyles}
                          placeholder={"ટાઈપ સિલેક્ટ કરો"}
                          options={typeOption}
                          onChange={(val: any) => setValue1("type", val?.value)}
                        />
                      )}
                    />
                  </div>

                  <div className="bg-gradient-to-r from-primary-1 to-primary-2 h-16 lg:h-11 w-full relative rounded">
                    <Controller
                      {...register1("amount_type")}
                      control={control1}
                      defaultValue={0}
                      render={({ field }) => (
                        <Select
                          isClearable
                          {...field}
                          value={
                            amountOption.find(
                              (val) => val.value === field.value
                            ) || null
                          }
                          className="text-primary-1 p-0 font-semibold text-xl placeholder:text-primary-2 absolute top-[2px] left-[2px] w-[calc(100%-4px)] h-[calc(100%-4px)] rounded"
                          styles={selectStyles}
                          placeholder={"અમાઉન્ટ ટાઈપ સિલેક્ટ કરો"}
                          options={amountOption}
                          onChange={(val: any) =>
                            setValue1("amount_type", val?.value)
                          }
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="flex gap-4 justify-end mt-4">
                  <button
                    onClick={handleClearExport}
                    type="button"
                    className="bg-primary-1 hover:bg-primary-2 text-white px-4 py-2 rounded-md transition duration-300 ease-in-out"
                  >
                    હટાઓ
                  </button>

                  <button
                    type="submit"
                    className="bg-primary-1 hover:bg-primary-2 text-white px-4 py-2 rounded-md transition duration-300 ease-in-out"
                  >
                    રિપોર્ટ બનાવો
                  </button>
                </div>
              </div>
            </form>
          )}

          <OrderList
            orders={orders}
            pageNumber={page}
            pageSize={pageSize}
            isLoading={isLoading}
            handleDeleteOrder={handleDeleteOrder}
            selectedOrderIds={selectedOrderIds}
            onToggleOrder={handleToggleOrder}
            onTogglePageOrders={handleTogglePageOrders}
          />

          <Pagination
            itemsPerPage={pageSize}
            totalItems={totalOrders}
            paginate={paginate}
            currentPage={page}
          />

          {isOrderModalOpen === true && (
            <OrdersFormModal handleSaveOrder={handleSaveOrder} />
          )}

          {isOrderPhotoModalOpen !== null && <PhotoModel />}
        </div>
      </div>
    </Layout>
  );
};
export default OrdersPage;
